import Terms from '../templates/Terms';
import { PageWrapper } from '../components';

export default PageWrapper(
  Terms,
  'Termos de uso | We Dash',
  'https://wedash.digital/terms',
);
